import { defaultTheme } from 'gd-design-library';
import { colors } from './colors';

export const select = {
  ...defaultTheme.select,
  default: {
    ...defaultTheme.select.default,
    width: 'auto !important'
  },
  dropdown: {
    ...defaultTheme.select.dropdown,
    paddingTop: 4,
    paddingBottom: 4,
    width: 'auto !important'
  },
  item: {
    ...defaultTheme.select.item,
    default: {
      ...defaultTheme.select.item.default,
      padding: '12px',
      display: 'flex',
      alignItems: 'center'
    }
  },
  arrowIconWrapper: {
    ...defaultTheme.select.arrowIconWrapper,
    default: {
      ...defaultTheme.select.arrowIconWrapper.default,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  },
  button: {
    ...defaultTheme.select.button,
    default: {
      ...defaultTheme.select.button.default,
      boxShadow: `inset 0 0 0 1px ${colors.neutral['grey.20']}`
    }
  }
};
